<template>
  <div class="principal py-gen">
    <div class="ui basic segment">
      <div class="ui inverted dimmer" v-bind:class="{ active: is_loading }">
        <div class="ui text loader">{{ $t("loading") }}</div>
      </div>
      <div class="px-gen">
        <!-- <pre>{{ bundle }}</pre> -->
        <h3 class="ui header pheader fdinpro is-uppercase mb-0">
          Bundle: {{ bundle.setup.name }}
        </h3>
        <h4 class="ui header fdinpro is-uppercase my-0 pl-3">
          Fecha de inicio: {{ bundle.setup.start_date }}
        </h4>
        <h4 class="ui header fdinpro is-uppercase my-0 pl-3">
          Fecha final: {{ bundle.setup.end_date }}
        </h4>
        <h4 class="ui header fdinpro is-uppercase my-0 pl-3">
          Materiales:
          <a :href="bundle.setup.assets_link">{{ bundle.setup.assets_link }}</a>
        </h4>
        <h4 class="ui header fdinpro is-uppercase my-0 pl-3">
          Total de envios: 30
        </h4>
      </div>
      <div class="ui search py-15 px-gen">
        <div class="ui icon input search-by-date">
          <input class="prompt" type="text" placeholder="Fecha DD/MM/AAAA" />
          <i class="search icon"></i>
        </div>
        <div class="results"></div>
      </div>
      <div class="table-codes- px-gen">
        <table class="ui very basic table" ref="table">
          <thead>
            <tr>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("serie") }}</th>
              <th>{{ $t("gpu") }}</th>
              <th>{{ $t("product") }}</th>
              <th>{{ $t("brand") }}</th>
              <th>{{ $t("bill") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>10 / 12 / 2021</td>
              <td>6636</td>
              <td>RTX 3080 SUPER</td>
              <td>Desktop</td>
              <td>ASUS</td>
              <td>6636</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pre>{{ bundle }}</pre>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "NvidiaTicketStoreBundleDetail",
  data() {
    return {
      bundle: {
        setup: {},
      },
      is_loading: false,
    };
  },
  methods: {
    setBundle(bundle) {
      let vm = this;
      vm.is_loading = true;
      local_api(vm, "post", "/nvidia_ticket/store/do-get-bundle-info", {
        u: bundle.bundle_id,
      })
        .then(function(r) {
          console.log(r);
          vm.bundle = r;
        })
        .catch(function(err) {
          error_toast(err);
        })
        .finally(() => {
          vm.is_loading = false;
        });
    },
  },
};
</script>

<style scoped>
@import url("https://nworkforce.com/librerias/css/fonts/fonts.css");

.principal {
  flex: 54%;
  background-color: white;
  z-index: 4;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
    0 0 0 1px rgb(10 10 10 / 2%);
}
.py-gen {
  padding-top: 5.5rem;
  padding-bottom: 0;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
} /*gen controla padding de los 3 modulos principales*/

.fdinpro {
  font-family: "DINPro" !important;
}

.pheader {
  font-weight: 300;
  font-size: 1.5rem !important;
  padding: 0.5rem 0 !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.pl-3 {
  padding-left: 3rem !important;
}
.py-15 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.search-by-date {
  width: 100%;
}
.table-codes- {
  font-size: 90% !important;
  overflow-y: scroll;
  height: 62vh;
}
.table-codes- table thead tr th {
  padding-bottom: 0.25rem !important;
}
.table-codes- table tbody tr td {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
</style>
